import { CreditCardBlock } from './payment-creditcard';
import { B2BBlock } from './payment-b2b';
import { B2CBlock } from './payment-b2c';
import { PaypalBlock } from './payment-paypal';
import { BankListBlock } from './payment-banklist';
import { OneyFacilipay } from './payment-oneyfacilipay';
import { PrimaryPaymentBlock } from './payment-primary-block';
import { Homebanking } from './payment-homebanking';
import { Sofort } from './payment-sofort';
import { PaymentWithForm } from './payment-with-form';
import { IngenicoBlock } from './payment-ingenico';
import { OgoneBlock } from './payment-ogone';
import { checkStatus, clearCheckStatusTimer, displayModalPaidOrder, qrCodeGenerator } from './payment-qrcode';
import { formatUrl, getOrderParams, updateUrls, handleAcceptConditions, handleBillingAddress } from './payment-utils';
import { isFapiaoValid } from './fapiao';

import { i18n } from '@/commons/utils';

const moduleData = {
  container: null,
  isBookOrderLoaded: false,
  isBookOrderRedirect: false,
  isSubmitPaymentRequested: false,
  payButtons: null,
  //methods exposed to mops
  //todo use proper imports instead of this method (!! express checkout)
  addFapiaoParams,
  checkBillingAddress,
  checkTermsOfUse,
  disableButton,
  displayError,
  displayLoader,
  enableButton,
  getAnalyticsInfos,
  hideLoader,
  isFullSecondaryPayment,
  loadJs,
};

export function init() {
  if ($('#payment-confirmation-authorization').val() === 'false') {
    window.location.href = '/';
  }

  $('#modal-reused-expiration').on('hide.bs.modal', () => {
    window.location = '/';
  });

  updateUrls();
  updateAmount();

  moduleData.payButtons = document.querySelectorAll('.dkt-checkout-primary-button');
  initMops();
  events();
  cube.event.on('reinit-checkout-billing-address', events);
  handlePaymentError();
  displayPrivacyRules();

  checkCouponConsumed();
}

function initMops() {
  const paymentMethods = document.querySelectorAll('.dkt-block');
  moduleData.container = document.querySelector('body');
  [...paymentMethods].map((paymentMethod, index) => {
    const PaymentName = paymentMethod.getAttribute('data-payment-name');
    const params = {
      parent: moduleData,
      container: paymentMethod,
      selected: index === 1,
      isCheckout: true,
      orderId: window.tc_vars.order_id,
    };
    if (PaymentName !== null) {
      switch (PaymentName) {
        case 'PAYON_-_CREDITCARD':
          params.canAddNewCard =
            document.querySelector('[data-payment-name=PAYON_-_CREDITCARD] .dkt-flipable') !== null;
          new CreditCardBlock().init(params);
          break;
        case 'MANUAL_-_BANK_TRANSFER_B2B':
          new B2BBlock(moduleData).init(params);
          break;
        case 'MANUAL_-_BANK_TRANSFER_B2C':
          new B2CBlock(moduleData).init(params);
          break;
        case 'BRAINTREE_-_PAYPAL':
          new PaypalBlock(moduleData).init(params);
          break;
        case 'ALIPAY_EBANK':
        case 'PAYON_-_IDEAL':
          new BankListBlock().init(params);
          break;
        case 'OGONE_-_HOMEBANKING':
          new Homebanking().init(params);
          break;
        case 'SOFORT_-_BANKING':
          new Sofort().init(params);
          break;
        case 'PAYON_-_AFTERPAY':
        case 'PAYOLUTION_-_OPEN_INVOICE':
        case 'ONEY_-_CB3X':
        case 'ONEY_-_CB4X':
          new PaymentWithForm().init(params);
          break;
        case 'INGENICO_-_CREDITCARD':
          params.canAddNewCard =
            document.querySelector('[data-payment-name=INGENICO_-_CREDITCARD] .dkt-flipable') !== null;
          new IngenicoBlock(moduleData).init(params);
          break;
        case 'INGENICOV2_-_CREDITCARD':
          params.canAddNewCard =
            document.querySelector('[data-payment-name=INGENICOV2_-_CREDITCARD] .dkt-flipable') !== null;
          new IngenicoBlock(moduleData).init(params);
          break;
        case 'ONEY_-_FACILYPAY':
          new OneyFacilipay().init(params);
          break;
        case 'OGONE_-_CREDITCARD':
          params.canAddNewCard =
            document.querySelector('[data-payment-name=OGONE_-_CREDITCARD] .dkt-flipable') !== null;
          new OgoneBlock(moduleData).init(params);
          break;
        default:
          new PrimaryPaymentBlock(moduleData).init(params);
          break;
      }
    }
    return null;
  });
}

function enableButton() {
  [...moduleData.payButtons].forEach(button => {
    button.classList.remove('disabled');
    button.disabled = false;
  });
}

function disableButton() {
  [...moduleData.payButtons].forEach(button => {
    button.classList.add('disabled');
    button.disabled = true;
  });
}

function displayLoader() {
  moduleData.container.classList.add('loading');
}

function hideLoader() {
  moduleData.container.classList.remove('loading');
}

function events() {
  const body = $('body');
  body
    .off('click', '.dkt-checkout-primary-button, #pay-order-mob-btn')
    .on('click', '.dkt-checkout-primary-button, #pay-order-mob-btn', e => {
      handleClickOnPay();
      const targetClasses = e.currentTarget.classList;
      if (!targetClasses.contains('disabled') && !targetClasses.contains('refund-payment-btn')) {
        moduleData.isSubmitPaymentRequested = true;
        checkPaymentValidity();
      }
    });

  //only on checkout payment and not in product page
  if (
    document.body.classList.contains('checkout-payment') &&
    $('.dkt-checkout-actions').attr('data-async-booking') === 'true'
  ) {
    callAjaxBookOrder();
  }

  document.addEventListener('SecondaryPaymentChanged', updateAmounts);

  body.on('DOMSubtreeModified', '.right-col', () => {
    updateAmount();
  });

  // Close QRCode modal
  $('#modal-alipay, #modal-wechat').on('hide.bs.modal', () => {
    checkStatus(() => {
      window.location.reload();
    });
  });

  // Retry QRCode
  body.on('click', '#modal-retry-wechat button.cta, #modal-retry-alipay button', e => {
    if ($(e.currentTarget).parents('#modal-express-payment-layout') === true) {
      sendRetryRequest(true);
    } else {
      sendRetryRequest(false);
    }
  });

  // Alipay alternative payment
  $('#alipay-direct-pay-button').on('click', e => {
    e.preventDefault();

    clearCheckStatusTimer();
    $('#alipayFrame').attr('src', '');
    $('#modal-retry-alipay').hide();
    $('#alipay-countdown-qrcode').show();

    const altPaymentGroupId = $('#modal-alipay').attr('data-alt-payment-group-id');
    submitPayment(false, altPaymentGroupId);
  });
}

function handleClickOnPay() {
  document.dispatchEvent(new CustomEvent('clickedOnPay'));
}

function updateAmounts(data) {
  let amount;
  if (data instanceof CustomEvent) {
    ({ amount } = data.detail);
  }

  const totalOrder = parseFloat($('#pay-order-btn[data-amount]').attr('data-amount'));
  const leftToPay = parseFloat(Math.round((totalOrder - amount) * 1000) / 1000).toFixed(2);
  const indicators = document.querySelectorAll('[data-role=primary-amount-used]');
  [...indicators].forEach(indicator => {
    indicator.setAttribute('data-primary-amount', leftToPay);
    indicator.innerText = cube.priceFormatter(leftToPay);
  });

  if (leftToPay > 0) {
    enablePrimaryMop();
  } else {
    disablePrimaryMop();
  }
}

function enablePrimaryMop() {
  $('[data-role=full-secondary-message]').addClass('hidden');
  $('[data-payment-name]').removeClass('hidden');
}

function disablePrimaryMop() {
  $('[data-role=full-secondary-message]').removeClass('hidden');
  $('[data-payment-name]').addClass('hidden');
}

export function displayError(message, settings) {
  const alertParams = Object.assign(
    {
      text: message,
      type: 'danger',
      icon: 'bell',
      delay: 20000,
    },
    settings
  );
  $('#main-container').pushAlert(alertParams);
}

function getAnalyticsInfos() {
  if (
    (window.AnalyticsConstants && window.AnalyticsConstants.isServerSideActive) ||
    window.cube.config.anly_useLegacy === 'N'
  ) {
    const fwk = window.cube.config.anly_useLegacy === 'Y' ? CUBE.Analytics : CUBE.Anly;
    return {
      ga_common: encodeURIComponent(fwk.serverside.getGACommon()),
      ga_dimensions: encodeURIComponent(fwk.serverside.getGADimensions()),
    };
  }
  return null;
}

function loadJs(src, id, callback) {
  return new Promise(resolve => {
    const jsElm = document.createElement('script');

    jsElm.type = 'text/javascript';
    jsElm.src = src;
    jsElm.id = id;
    document.querySelector('head').appendChild(jsElm);
    jsElm.onload = () => {
      resolve();
      if (callback) {
        callback();
      }
    };
  });
}

function checkTermsOfUse() {
  const acceptConditions = document.getElementById('acceptConditions');
  const termsOfUseContainer = document.querySelector('.dkt-terms-of-use');

  if (termsOfUseContainer !== null && acceptConditions !== null && acceptConditions.checked === false) {
    displayError(i18n('payment.accept.termsAndConditions'));
    termsOfUseContainer.classList.add('dkt-terms-of-use--error');
    hideLoaderOrderBtn();
    return false;
  }
  hideTermsOfUseError();
  return true;
}

function hideTermsOfUseError() {
  const termsOfUseContainer = document.querySelector('.dkt-terms-of-use');
  if (termsOfUseContainer !== null) {
    termsOfUseContainer.classList.remove('dkt-terms-of-use--error');
    enableButton();
  }
}

export function checkBillingAddress() {
  const billingAddress = document.getElementById('billing-address-container');
  if (billingAddress !== null) {
    const errorMessage = billingAddress.querySelector('.js-block-message-text');
    if (errorMessage !== null) {
      displayError(i18n('payment.message.billingAddress'));
      billingAddress.classList.add('dkt-billing-address--error');
      hideLoaderOrderBtn();
      return false;
    }
    hideBillingAddressError();
    return true;
  }
  return true;
}

function hideBillingAddressError() {
  const billingAddress = document.getElementById('billing-address-container');
  billingAddress.classList.remove('dkt-terms-of-use--error');
}

function addFapiaoParams(params) {
  if (!$('#fapiao-block .panel-heading').hasClass('collapsed') && $('#fapiao-invoice').val() !== 'noselection') {
    const fields = document.querySelectorAll('#payment-informations [name^="fapiao"]');
    [...fields].forEach(field => {
      params[field.name] = field.value;
    });
  }
  return params;
}

function displayPrivacyRules() {
  cube.cartridge('privacy-rules-section').reload({ context: 'PaymentPage' });
}

function isFullSecondaryPayment() {
  const secondaryMessage = document.querySelector('.dkt-checkout-message');
  return secondaryMessage !== null && !secondaryMessage.classList.contains('hidden');
}

function handlePaymentError() {
  const hasPaymentError = document.querySelector('.js-has-error');

  if (hasPaymentError) {
    const countdownContent = $('#alert-wrapper .wrapper .text').html();

    displayError(i18n('payment.error.message'), {
      onClose: () => {
        displayError(countdownContent, {
          type: 'info',
          icon: 'animate-icon chrono',
          delay: 0,
        });
        window.decathlon.tools.countdown($('.countdown'));
      },
    });
  }
}

function checkCouponConsumed() {
  const consumedCoupon = window.getURLParameter('usedCoupon');
  if (consumedCoupon) {
    const errorToDisplay = i18n('coupon.already.consumed', consumedCoupon);
    displayError(errorToDisplay);
    const replaced = `&usedCoupon=${consumedCoupon}`;
    window.history.pushState({}, null, window.location.href.replace(replaced, ''));
  }

  const tooltipMessage = $('[data-tid=order-unused-coupon-message]').text() || '';
  $('.dkt-checkout-primary-button').attr('title', tooltipMessage);

  if (tooltipMessage === '') {
    const tooltip = getTooltip();
    hideTooltip(tooltip);
  }
}

function getTooltip() {
  let alreadyClose = false;

  // tooltip on btn order
  const orderButton = $('#main-container .payment-bar a.cta.yellow');
  orderButton
    .tooltip({
      container: '.payment-bar .col-sm-10',
      placement: (tooltip, trigger) => {
        window.decathlon.basket.tooltipPlacement(tooltip, trigger, alreadyClose);
        return window.decathlon.uxBreakpoints.is('large-screen') ? 'left' : 'top';
      },
      template:
        '<div role="tooltip" class="tooltip tooltip-alert info"><div class="container-icon"><span class="animate-icon"><span class="bell"></span><span class="vibe"></span></span></div><div class="tooltip-arrow"></div><div class="tooltip-inner"></div><span class="close icon icon-x"></span></div>',
    })
    .tooltip('show');

  $('#main-container .payment-bar .tooltip .close').on('click', () => {
    $('#main-container .payment-bar .tooltip').tooltip('destroy');
    alreadyClose = true;
  });

  return orderButton;
}

function hideTooltip(tooltipElt) {
  tooltipElt.tooltip('hide');
}

export function sendRetryRequest(isExpress) {
  checkStatus(() => {
    const params = getOrderParams();
    const finalUrl = formatUrl('applyPayment', params.orderId);

    params.useSecondaryMop = $('[data-role=secondary-payment-block]').hasClass('dkt-block--open');

    window.decathlon.tools.displayLoader(true, false, $('.modal-dialog'));

    if (!isExpress) {
      params.reusePaymentGroups = true;
    }

    window
      .getAjaxHandler()
      .withUrl(finalUrl)
      .withParameters(params)
      .withSuccess(submitPaymentSuccess)
      .call();
  });
}

function updateAmount() {
  const total = $('.dkt-total-line-amount').html();
  $('.dkt-total strong').html(total);
}

function checkPaymentValidity() {
  const isFullSecondary = !$('[data-role=full-secondary-message]').hasClass('hidden');

  // Means of payment with dedicated module
  const newPayments = [
    'OGONE_-_HOMEBANKING',
    'PAYON_-_CREDITCARD',
    'BRAINTREE_-_PAYPAL',
    'BANK_TRANSFER_B2B',
    'BANK_TRANSFER_B2C',
    'PAYON_-_IDEAL',
    'ALIPAY_EBANK',
    'PAYON_-_AFTERPAY',
    'SOFORT_-_BANKING',
    'PAYOLUTION_-_OPEN_INVOICE',
    'INGENICO_-_CREDITCARD',
    'INGENICOV2_-_CREDITCARD',
    'OGONE_-_CREDITCARD',
    'ONEY_-_CB3X',
    'ONEY_-_CB4X',
    'ONEY_-_FACILYPAY',
  ];

  const selectedBlock = cube.$('[data-payment-name].dkt-block--selected');
  if (!selectedBlock && !isFullSecondary) {
    return;
  }

  const paymentName = selectedBlock && selectedBlock.dataset.paymentName;
  const isTestPayment =
    paymentName && String.prototype.endsWith
      ? paymentName.endsWith('_MONO') === true || paymentName.endsWith('_DENIED') === true
      : false;

  let isNewPayment = false;

  if (isFullSecondary === false) {
    isNewPayment = newPayments.some(
      payment => paymentName === payment || (paymentName && paymentName.includes(payment))
    );
  }

  if (isFullSecondary === true || isNewPayment === false || isTestPayment === true) {
    preparePayment();
  }
}

function preparePayment() {
  if ($('.dkt-checkout-actions').attr('data-async-booking') === 'true') {
    displayLoaderOrderBtn($('#pay-order-btn, .dkt-checkout-primary-button'));
    //todo do this without $.when and $.Deferred with regular promise
    callAjaxBookOrder().then(() => {
      submitPayment();
    });
  } else {
    submitPayment();
  }
}

export function submitPayment(reusePaymentGroups, alternativePayment) {
  let params;
  let inputsToSerialize = '[name="redirectionUrl"], [name="wechatSuccessPageUrl"],[name="orderTrackingUrl"]';

  if (!$('#fapiao-block .panel-heading').hasClass('collapsed') && $('#fapiao-invoice').val() !== 'noselection') {
    inputsToSerialize = `#payment-informations [name^="fapiao"], ${inputsToSerialize}`;
  }

  if (!handleAcceptConditions()) return;
  if (!handleBillingAddress()) return;
  if (!isFapiaoValid()) return;

  params = $(inputsToSerialize).serialize();

  const isFullSecondary = !$('[data-role=full-secondary-message]').hasClass('hidden');

  if (!isFullSecondary) {
    if (alternativePayment) {
      params += `&paymentTypeId=${alternativePayment}`;
    } else {
      const paymentSelected = document.querySelector('section[data-payment-name].dkt-block--selected');
      const paymentTypeId = paymentSelected && paymentSelected.dataset.paymentTypeId;
      if (paymentTypeId) {
        params += `&paymentTypeId=${paymentTypeId}`;
      }
    }
  }

  if (reusePaymentGroups === true) {
    params += '&reusePaymentGroups=true';
  }

  params += `&useSecondaryMop=${isSecondaryBlockOpened()}`;
  params += `&paymentUrl=${encodeURIComponent(window.location.href)}`;

  if (
    (window.AnalyticsConstants && window.AnalyticsConstants.isServerSideActive) ||
    window.cube.config.anly_useLegacy === 'N'
  ) {
    const fwk = window.cube.config.anly_useLegacy === 'Y' ? CUBE.Analytics : CUBE.Anly;
    const jsonGACommon = `"ga_common" : "${encodeURIComponent(fwk.serverside.getGACommon())}"`;
    const jsonGADimensions = `"ga_dimensions" : "${encodeURIComponent(fwk.serverside.getGADimensions())}"`;

    params += `&orderAttributes={${jsonGACommon}, ${jsonGADimensions}}`;
  }

  if (!params || !params.length) {
    displayError($.validator.messages.noPaymentSelected);
  } else {
    if (!$('#modal-wechat').is(':visible') && !$('#modal-alipay').is(':visible')) {
      window.decathlon.tools.displayLoader(true, true);
    }

    $('#alert-wrapper').css('zIndex', 7000);

    window
      .getAjaxHandler()
      .withUrl(formatUrl('applyPayment', params.orderId))
      .withParameters(params)
      .withSuccess(submitPaymentSuccess)
      .call();
  }
}

export function scrollToElement(element) {
  const elementHeight = element[0].offsetHeight;
  const windowHeight = window.innerHeight;
  const scrollPosition = window.pageYOffset;
  const elementPosition = element.offset().top;
  let scrollTop;

  if (elementPosition + elementHeight - scrollPosition > windowHeight || scrollPosition > elementPosition) {
    scrollTop =
      elementHeight < windowHeight ? elementPosition - (windowHeight - elementHeight) / 2 : elementPosition - 5;

    if (scrollTop) {
      $('html, body')
        .stop(true, true)
        .animate(
          {
            scrollTop,
          },
          'fast'
        );
    }
  }
}

export function callAjaxBookOrder() {
  return new Promise((resolve, reject) => {
    if (moduleData.isBookOrderLoaded || $('.dkt-checkout-actions').attr('data-async-booking') === 'false') {
      resolve();
    } else {
      window
        .getAjaxHandler()
        .withUrl('rest/model/com/decathlon/cube/commerce/order/sap/BookingActor/bookOrder')
        .withSuccess(ajaxBookOrderSuccess)
        .withComplete(ajaxBookOrderComplete)
        .withTimeout(21000)
        .call();
    }

    function ajaxBookOrderSuccess(_, response) {
      if (!response.error) {
        moduleData.isBookOrderRedirect = response.responseTO.data;
      }

      const loadingIcon = $('#pay-order-btn, .dkt-checkout-primary-button').find('.loading-icon');
      if (loadingIcon.length) {
        loadingIcon.remove();
      }
    }

    function ajaxBookOrderComplete() {
      if (moduleData.isBookOrderRedirect === true) {
        displayError(i18n('INV_0001_checkout_cart_short'));

        setTimeout(() => {
          const url = window.location.href.split('/checkout')[0];
          window.location.href = `${url}/checkout/cart`;
        }, 5000);
      } else {
        moduleData.isBookOrderLoaded = true;
        resolve();
      }
    }
  });
}

function displayLoaderOrderBtn(button) {
  if (!button.find('.loading-icon').length) {
    button.prepend(
      '<img class="loading-icon" src="/assets/images/ajax-loader.gif" height="17" width="" alt="Loading" /> '
    );
    button.addClass('disabled').attr('disabled');
  }
}

export function hideLoaderOrderBtn() {
  const button = $('#pay-order-btn, .dkt-checkout-primary-button');
  const loadingIcon = button.find('.loading-icon');
  if (loadingIcon.length) {
    loadingIcon.remove();
    button.removeClass('disabled').attr('disabled', false);
  }
}

export function isSecondaryBlockOpened() {
  const secondaryPaymentBlock = document.querySelector('[data-role=secondary-payment-block]');
  return secondaryPaymentBlock && secondaryPaymentBlock.classList.contains('dkt-block--open');
}

function submitPaymentSuccess(_, response) {
  checkResponseError(response);

  const result = response.result;
  if (result) {
    // Track "ProceedToConfirmation" event (in queue) after validation only

    if (window.cube.config.anly_useLegacy === 'Y') {
      CUBE.Analytics.queue.send('proceedToConfirmation');
    }
    if (result.data.paymentModifiable === 'false') {
      window.location.reload();
    }
    if (result.data.redirectConfirmation === 'false') {
      if (result.data.displayModalPaidOrder !== undefined) {
        // Show Modal Have you paid ?
        displayModalPaidOrder(result.data);
      } else if (result.data.qrcodeUrl !== undefined) {
        qrCodeGenerator(result.data, 'wechat');
      } else if (result.data.iframe !== undefined) {
        qrCodeGenerator(result.data, 'alipay');
      } else if (result.data.paymentAction === 'REDIRECTION_DIRECT') {
        window.location.href = result.data.urlValidation;
      } else {
        // Nominal case : PSP Redirection
        const paymentRedirectForm = $('#payment-redirect-form');
        paymentRedirectForm.append(result.data.redirectPspForm);
        paymentRedirectForm.find('form').submit();
      }
      return;
    }

    if (result.data.redirectConfirmation === 'true') {
      window.location.href = result.data.redirectionUrl;
    }
    return;
  }
  if (response.responseTO !== undefined && response.responseTO.errors.length > 0) {
    document.dispatchEvent(new CustomEvent('ErrorAfterSubmit'));

    const error = response.responseTO.errors[0];
    if (error.code === 'PAY_0031') {
      $('#modal-nodata').modal('show');
    } else if (response.responseTO.errors[0].code !== 'couponAlreadyused') {
      displayError(i18n(error.code));
    }
  } else {
    $('.dkt-checkout-primary-button, #pay-order-mob-btn')
      .addClass('disabled')
      .prop('disabled', true);
    window.location.reload();
  }

  $('html, body').animate(
    {
      scrollTop: 0,
    },
    'slow'
  );
  window.decathlon.tools.displayLoader(false, false);
}

function checkResponseError(response) {
  $('#main-container > .alert.alert-danger').addClass('hide');
  if (!response) {
    displayError(i18n('error.oc.call'));
  } else if (response.responseTO !== undefined) {
    if (response.responseTO.errors[0].code === 'couponAlreadyused') {
      window.location.href = `${window.location.href}&usedCoupon=${response.responseTO.errors[0].message}`;
    } else {
      displayError(i18n(response.responseTO.errors[0].code));
    }
  } else if (response.result !== undefined && response.result.data === false) {
    console.error(response.result.errors[0]);
  }
}



// WEBPACK FOOTER //
// ./src/checkout/payment/payment.js